import { OnlineCouponsApiClient } from '@jbhi-fi/apis/src/onlineCouponsApi/OnlineCouponsApiClient';
import { useQuery } from 'react-query';
import { serviceHelper } from '../../../config/service-helper';
import { Exclusions } from '@jbhi-fi/apis/src/onlineCouponsApi/types';

const country = window.Jbhifi.storeLocation;
const couponApiClient = new OnlineCouponsApiClient({
  baseUrl: `${serviceHelper.themeApisUrl}/coupons`,
  countryCode: country,
});

export const useCouponExclusions = (couponIds: Array<string> | undefined) => {
  return useQuery({
    queryKey: ['couponExclusions', (couponIds || []).sort()],
    enabled: !!couponIds?.length,
    queryFn: async () => {
      const exclusionsPromises = couponIds?.map(async externalId => {
        try {
          const response = await couponApiClient.getExclusions(externalId);
          return response.data;
        } catch (error) {
          console.error('Error finding exclusions for coupon:', error);
          return undefined;
        }
      });

      if (!exclusionsPromises) return;

      const exclusions = (await Promise.all(exclusionsPromises)).filter(Boolean) as Array<Exclusions>;
      const exclusionMap = new Map<string, Exclusions>();

      exclusions.forEach(item => {
        exclusionMap.set(item.externalId, item);
      });

      return exclusionMap;
    },
    staleTime: 1000 * 60 * 15, // 15 minutes
    refetchOnWindowFocus: false,
  });
};
